import { NgClass, NgIf } from '@angular/common';
import { Component, input, InputSignal } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

export type TCalloutVariant = 'error' | 'info' | 'neutral' | 'success' | 'warning';

@Component({
  imports: [MatIcon, NgClass, NgIf],
  selector: 'app-callout',
  standalone: true,
  styleUrl: './callout.component.scss',
  templateUrl: './callout.component.html',
})
export class CalloutComponent {
  public readonly variant: InputSignal<TCalloutVariant> = input<TCalloutVariant>('neutral');
  public readonly icon: InputSignal<string> = input<string>('');
  public readonly title: InputSignal<string> = input<string>('');
  public readonly description: InputSignal<string> = input<string>('');
  public readonly dense: InputSignal<boolean> = input<boolean>(false);
}
